import { axiosApi as axios } from '@/axios'
import { createOrUpdate, createOrUpdateJSON } from '@/utils/functions'
import { Paginator, Params } from '@/utils/interfaces'
import { AxiosResponse } from 'axios'
import { Dictionary } from 'vue-router/types/router'

export const createOrUpdateFormData = <T>(
  url: string,
  body: Dictionary<any>,
  imageField?: string,
): Promise<AxiosResponse<T>> => {
  const formdata = new FormData()

  for (const key in body) {
    if (
      !(
        imageField &&
        key === imageField &&
        body[key] &&
        typeof body[key] !== 'object'
      )
    ) {
      formdata.append(key, body[key])
    }
  }

  if (body.uuid) {
    return axios.patch<T>(`${url}${body.uuid}/`, formdata, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } else {
    return axios.post<T>(url, formdata, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}

export interface ToggleBody {
  uuid: string
  [key: string]: boolean | string
}

export type GetterFunction<T> = (
  params?: Params,
) => Promise<AxiosResponse<Paginator<T>>>
export type GetterByIdFunction<T> = (uuid: string) => Promise<AxiosResponse<T>>
export type CreateOrUpdateFunction<B, R> = (
  body: B,
) => Promise<AxiosResponse<R>>
export type ToggleFunction<T> = (
  body: ToggleBody,
  toggleField?: string,
) => Promise<AxiosResponse<T>>
export type DeleteFunction<T> = (uuid: string) => Promise<AxiosResponse<T>>

export class ApiController<GetType = {}, CreateOrUpdateDTO = {}> {
  createOrUpdate2Steps: CreateOrUpdateFunction<CreateOrUpdateDTO, GetType>
  createOrUpdateFormData: CreateOrUpdateFunction<CreateOrUpdateDTO, GetType>
  createOrUpdateJson: CreateOrUpdateFunction<CreateOrUpdateDTO, GetType>
  delete: DeleteFunction<GetType>
  getter: GetterFunction<GetType>
  getterById: GetterByIdFunction<GetType>
  toggle: ToggleFunction<GetType>

  constructor(url: string, imageField = '') {
    this.getter = (params?: Params) =>
      axios.get<Paginator<GetType>>(url, { params })

    this.getterById = (uuid: string) => axios.get<GetType>(`${url}${uuid}/`)

    this.delete = (uuid: string) => axios.delete<GetType>(`${url}${uuid}/`)

    this.createOrUpdateJson = (body: CreateOrUpdateDTO) =>
      createOrUpdateJSON<GetType>(url, body)

    this.createOrUpdateFormData = (body: CreateOrUpdateDTO) =>
      createOrUpdateFormData<GetType>(url, body, imageField)

    if (imageField) {
      this.createOrUpdate2Steps = (body: CreateOrUpdateDTO) =>
        createOrUpdate<GetType>(url, body, imageField)
    } else {
      this.createOrUpdate2Steps = (body: CreateOrUpdateDTO) =>
        createOrUpdateJSON<GetType>(url, body)
    }

    this.toggle = (body: ToggleBody, field = 'is_active') =>
      axios.patch<GetType>(url + `${body.uuid}/`, {
        [field]: body[field],
      })
  }
}
